import React, { useCallback } from "react";
import { Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import calculateAvgRating from "../utils/avgRating";
import "./tour-card.css";

// WhatsApp deep link generator (client-side only)
const getWhatsAppURL = (tourTitle, tourCity) => {
  const message = `Hello Oscar Global,

I'm interested in this tour:
📍 ${tourCity}
🎯 ${tourTitle}

Could you share availability, group size options, and pricing?

—
Sent via web •`;

  const encoded = encodeURIComponent(message)
    .replace(/\(/g, '%28')
    .replace(/\)/g, '%29')
    .replace(/'/g, '%27')
    .replace(/%20/g, '+');

  return `https://wa.me/2348077854009?text=${encoded}`;
};

const TourCard = ({ tour }) => {
  const { id, title, city, photo, featured, reviews } = tour;
  const { avgRating, totalRating } = calculateAvgRating(reviews);

  // Memoized WhatsApp handler (avoids recreation on every render)
  const handleWhatsAppClick = useCallback((e) => {
    e.preventDefault();
    const url = getWhatsAppURL(title, city);
    
    // Primary: open in new tab
    const win = window.open(url, '_blank', 'noopener,noreferrer,width=540,height=800');
    if (!win) {
      // Fallback: DOM injection
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => document.body.removeChild(a), 50);
    }
  }, [title, city]);

  return (
    <div className="tour__card">
      <Card className="tour__card-Card h-100">
        <div className="tour__img position-relative">
          <img 
            src={photo} 
            alt={title} 
            loading="lazy"
            className="w-100"
            style={{ 
              borderTopLeftRadius: '8px', 
              borderTopRightRadius: '8px',
              objectFit: 'cover',
              height: '180px'
            }} 
          />
          {featured && (
            <span 
              className="featured-badge position-absolute top-0 start-0 m-2 px-2 py-1"
              style={{
                background: 'linear-gradient(135deg, #0d9488, #065f46)',
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.8rem',
                fontWeight: 500,
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
              }}
            >
              Featured
            </span>
          )}
        </div>

        <CardBody className="d-flex flex-column">
          <div className="card__top d-flex align-items-center justify-content-between mb-2">
            <span className="tour__location d-flex align-items-center">
              <i className="ri-map-pin-line me-1"></i> 
              <span className="fw-medium">{city}</span>
            </span>
            <span className="tour__rating d-flex align-items-center">
              <i className="ri-star-fill text-warning me-1"></i>
              {avgRating ? (
                <>
                  <span className="fw-semibold">{avgRating}</span>
                  {totalRating > 0 && (
                    <small className="text-muted ms-1">({reviews.length})</small>
                  )}
                </>
              ) : (
                <span className="text-muted">Not rated</span>
              )}
            </span>
          </div>

          <h5 className="tour__title mb-3">
            <Link 
              to={`/tours/${id}`} 
              className="text-decoration-none text-dark"
              style={{ 
                WebkitLineClamp: 2,
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                fontWeight: 600 
              }}
            >
              {title}
            </Link>
          </h5>

          {/* ✅ WhatsApp CTA — replaces booking */}
          <div className="mt-auto">
            <button
              onClick={handleWhatsAppClick}
              className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2 mt-2"
              style={{
                background: 'linear-gradient(135deg, #0d9488, #065f46)',
                color: 'white',
                borderRadius: '12px',
                fontWeight: 600,
                fontSize: '0.95rem',
                boxShadow: '0 2px 8px rgba(13, 148, 136, 0.3)',
                border: 'none',
                transition: 'transform 0.2s, box-shadow 0.2s'
              }}
              onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.98)'}
              onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <i className="ri-whatsapp-line"></i>
              <span>Inquire on WhatsApp</span>
            </button>

            {/* Subtle privacy assurance */}
            {/* <small 
              className="d-block text-center mt-2"
              style={{ 
                color: '#0d9488', 
                fontSize: '0.75rem',
                lineHeight: 1.4 
              }}
            >
              <i className="ri-shield-check-line me-1"></i>
              End-to-end encrypted • No forms
            </small> */}
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default React.memo(TourCard);






























// import React from "react";
// import { Card, CardBody } from "reactstrap";
// import { Link } from "react-router-dom";
// import calculateAvgRating from "../utils/avgRating";
// import "./tour-card.css";

// const TourCard = ({ tour }) => {
//   const { id, title, city, photo, price, featured, reviews } = tour;
//   const { totalRating, avgRating } = calculateAvgRating(reviews);

//   return (
//     <div className="tour__card">
//       <Card xm='12' className="tour__card-Card">
//         <div className="tour__img">
//           <img src={photo} alt={title} loading="lazy" />
//           {featured && <span className="featured-badge">Featured</span>}
//         </div>

//         <CardBody>
//           <div className="card__top d-flex align-items-center justify-content-between">
//             <span className="tour__location">
//               <i className="ri-map-pin-line"></i> {city}
//             </span>
//             <span className="tour__rating">
//               <i className="ri-star-fill"></i>
//               {avgRating || "Not rated"}
//               {totalRating > 0 && <span> ({reviews.length})</span>}
//             </span>
//           </div>

//           <h5 className="tour__title">
//             <Link to={`/tours/${id}`}>{title}</Link>
//           </h5>
//           {/* I removed tour booking  */}

          
//           {/* <div className="card__bottom d-flex align-items-center justify-content-between mt-3">
//             <h5>${price} <span>/per person</span></h5>
//             <Link to={`/tours/${id}`} className="btn booking__btn text-white">
//               Book Now
//             </Link>
//           </div> */}
//         </CardBody>
//       </Card>
//     </div>
//   );
// };

// export default React.memo(TourCard);





// import React from "react";
// import { Card, CardBody } from "reactstrap";
// import { Link } from "react-router-dom";
// import calculateAvgRating from "../utils/avgRating";
// import "./tour-card.css";

// const TourCard = ({ tour }) => {
//   const { _id, title, city, photo, price, featured, reviews } = tour;
//   const { totalRating, avgRating } = calculateAvgRating(reviews);

//   return (
//     <div className="tour__card">
//       <Card>
//         <div className="tour__img">
//           <img src={photo} alt={title} loading="lazy" />
//           {featured && <span className="featured-badge">Featured</span>}
//         </div>

//         <CardBody>
//           <div className="card__top d-flex align-items-center justify-content-between">
//             <span className="tour__location">
//               <i className="ri-map-pin-line"></i> {city}
//             </span>
//             <span className="tour__rating">
//               <i className="ri-star-fill"></i>
//               {avgRating || "Not rated"}
//               {totalRating > 0 && <span> ({reviews.length})</span>}
//             </span>
//           </div>

//           <h5 className="tour__title">
//             <Link to={`/tours/${_id}`}>{title}</Link>
//           </h5>

//           <div className="card__bottom d-flex align-items-center justify-content-between mt-3">
//             <h5>${price} <span>/per person</span></h5>
//             <Link to={`/tours/${_id}`} className="btn booking__btn text-white">
//               Book Now
//             </Link>
//           </div>
//         </CardBody>
//       </Card>
//     </div>
//   );
// };

// export default React.memo(TourCard);